var $header = $('header');
var $navHeight = $('nav.menu').outerHeight();
var $logoHeight = $('#top-logo').outerHeight();
var $adminBar = $('body.admin-bar');
var $bar;
if($adminBar.length >0 && $(window).width() > 1200) {
    $bar = 32;
}
else {
    $bar = 0;
}

if($header.length > 0) {
    let headerHeight = $header[0].offsetHeight;
    let lastScrollTop = 0;

     // Menu on scroll
    $(window).scroll(function (e) {
        let scrollTop = $(this).scrollTop();
        if (scrollTop <= 2) {
            $header.removeClass('sticky animate show')
        } 
        else if (scrollTop === 0) {
            $header.removeClass('sticky animate show')
        } 
        else if (scrollTop > headerHeight + $bar) {
            if (scrollTop < lastScrollTop) { // Scrolling up
                $header.addClass('sticky animate show')
            } else {
                $header.addClass('sticky').removeClass('show');
            }
        }
        lastScrollTop = scrollTop;
    });

    var $hero = $('#content-section .hero');
    var $heroSlideshow = $('#content-section .hero-slideshow');
    var $imageTextBox = $('#content-section section.image-text-box');
    var $consecutiveImageTextBoxes = [];
    $imageTextBox.each(function(index) {
        if ($imageTextBox.eq(index).prev().hasClass('image-text-box')) {
            $consecutiveImageTextBoxes.push($imageTextBox.eq(index));
        }
    });
    if ($consecutiveImageTextBoxes.length > 0) {
        $consecutiveImageTextBoxes[$consecutiveImageTextBoxes.length-1].addClass('more-padding');
    }


    if ($hero.length > 0 && $hero.next().hasClass('image-text-box')) {
        $('body').addClass('has-hero');
        $('body').addClass('menu-absolute');
    }
    else if ($hero.length > 0 || $heroSlideshow.length > 0) {
        $('body').addClass('menu-absolute');
    }
    else {
        $('#content-section section.image-text-box').last().addClass('bottom-padding');
    }
}

function applySearchToggle($form) {
    $form.find('.submit-button').on('click.searchToggle', function (e) {
        if (!$form.hasClass('is-open')) {
            e.preventDefault();
            $form.addClass('is-open');
            $form.find('input[type="text"]').focus();
        } else if ($form.find('input[type="text"]').val().trim() === '') {
            e.preventDefault();
            $form.removeClass('is-open');
        }
    });

    $form.on('submit.searchToggle', function (e) {
        if ($form.find('input[type="text"]').val().trim() === '') {
            e.preventDefault();
            $form.removeClass('is-open');
        }
    });
}

function removeSearchToggle($form) {
    $form.find('.submit-button').off('.searchToggle');
    $form.off('.searchToggle');
    $form.removeClass('is-open');
}

var $desktopSearch = $('header form#search:not(.mobile)');
if ($desktopSearch.length > 0) {
    applySearchToggle($desktopSearch);
}

var $mobileSearch = $('header form#search.mobile');
if ($mobileSearch.length > 0) {
    var mq1400 = window.matchMedia('(min-width: 1400px)');
    if (mq1400.matches) {
        applySearchToggle($mobileSearch);
    }
    mq1400.addEventListener('change', function (e) {
        if (e.matches) {
            applySearchToggle($mobileSearch);
        } else {
            removeSearchToggle($mobileSearch);
        }
    });
}

$(document).on('click', function (e) {
    if (!$(e.target).closest('header form#search').length) {
        $('header form#search').removeClass('is-open');
    }
});